import { getKioskDisplayName } from 'shared/helpers/orders';
import { getPersistedKioskName } from 'src/hooks/use-capture-kiosk-id';

/**
 * Display name for the lock-screen kiosk identity chip. Driven entirely by device-local state
 * (no dispensary query dependency, so it's correct the instant a kiosk is claimed instead of
 * waiting out the `ConsumerDispensaries` cache). Prefers the admin-typed name persisted at claim
 * time; falls back to de-slugifying the id for devices claimed before that name was persisted.
 */
export function useKioskDisplayName(originKioskId: string | null): string | null {
  if (!originKioskId) {
    return null;
  }

  return getPersistedKioskName() ?? getKioskDisplayName(originKioskId);
}
